<template>
  <div class="modal fade" id="RecordManualPayment" tabindex="-1" aria-hidden="true">
    <div class="modal-dialog modal-lg" role="document">
      <div class="modal-content">
        <div class="modal-header">
          <div class="container-fluid">
            <div class="row">
              <div class="col-9 my-auto">
                <h5 class="modal-title" id="RecordManualPaymentLabel">Manual Payment or Refund</h5>
              </div>
              <div class="col-3 my-auto">
                <div>
                  <div>
                    <span><a class="close"><i class="far fa-times-circle fa-2x" data-dismiss="modal"
                          id="closeManualPayment" aria-label="Close"></i></a></span>
                  </div>
                  <div>
                    <!-- <router-link :to="{ path: '/dashboard'}" target="_blank">
                                      <span class="fa-stack fa-2x fsm float-right">
                                          <i class="far fa-circle fa-stack-2x"></i>
                                          <i class="fas fa-external-link-alt fa-stack-1x"></i>
                                      </span>
                                  </router-link> -->
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <form @submit.prevent="submit">
          <div class="modal-body">
            <div class="container-fluid">
              <div class="row">
                <div class="col-lg-12">
                  <div class="row">
                    <div class="col-sm-12">
                      <div class="row">
                        <div class="col-lg-12">
                          <div class="row">
                            <div class="col-sm-12">
                              <div class="row h-100 py-3">
                                <div class="col-md-6 col-lg-4 mb-3 text-left">
                                  <p class="mb--20 mb-1 text-left">
                                    <label for="pickAdate" class="font-weight-bold">Pick
                                      a date:</label>
                                  </p>
                                  <el-date-picker v-model="pickerDate" format="dd.MM.yyyy" value-format="yyyy-MM-dd"
                                    type="date" required>
                                  </el-date-picker>
                                </div>
                                <div class="col-md-6 col-lg-4 mb-3">
                                  <p class="mb--20 mb-1 text-left">
                                    <label for="exampleFormControlTextarea6" class="font-weight-bold">Enter
                                      an amount</label>
                                  </p>
                                  <div class="form-group">
                                    <div class="input-group">
                                      <div class="input-group-prepend">
                                        <span class="input-group-text" id="basic-addon1">£</span>
                                        <!-- <label for="exampleFormControlTextarea6"
                                                                            class="font-weight-bold">Enter
                                                                            an amount</label>
                                                                    </p>
                                                                    <div class="form-group row">
                                                                        <div class="col-sm-12">-->
                                        <!-- <input type="number" step=".01" class="form-control" id="inputAmount" v-model="amount" placeholder="Eg: £10.00" required> -->
                                        <!-- <div class="input-group-prefix prefix">
                                                                                <span class="input-group-addon">£</span> -->
                                        <input type="number" step=".01" class="prefix" id="inputAmount" v-model="amount"
                                          placeholder="Eg: 10.00" required>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                                <div class="col-md-12 col-lg-4">
                                  <p class="mb--20 mb-1 text-left">
                                    <label for="exampleFormControlTextarea6" class="font-weight-bold">Type:</label>
                                  </p>
                                  <b-form-select v-model="type" class="mb-3" required>
                                    <!-- <option :value="null">Please select an option</option> -->
                                    <option value="Payment">Payment</option>
                                    <option value="Refund">Refund</option>
                                    <!-- <option value="Reverse_In">Reverse In</option>
                                                                        <option value="Reverse_Out">Reverse Out</option>
                                                                        <option value="Transfer_In">Transfer In</option>
                                                                        <option value="Transfer_Out">Transfer Out</option> -->
                                  </b-form-select>
                                </div>
                                <!-- </div> -->
                              </div>
                            </div>
                          </div>
                          <div class="row">
                            <div class="col-lg-6 col-lg-4">
                              <p class="mb--20 mb-1 text-left">
                                <label for="exampleFormControlTextarea6" class="font-weight-bold">Source:</label>
                              </p>
                              <b-form-select v-model="source" class="mb-3" required>
                                <!-- <option :value="null">Please select an option</option> -->
                                <option value="BACS">BACS</option>
                                <option value="Cash">Cash</option>
                                <option value="Card_American_Express">Card - American
                                  Express</option>
                                <option value="Card_Discover">Card - Discover</option>
                                <option value="Card_Maestro">Card - Maestro</option>
                                <option value="Card_Mastercard">Card - Mastercard
                                </option>
                                <option value="Card_Visa">Card - Visa</option>
                                <option value="Cheque">Cheque</option>
                                <option value="DD">Direct Debit</option>
                                <option value="Debt_Recovery">Debt Recovery</option>
                              </b-form-select>
                              <!-- If Reverse or Transfer is selected on thr type dropdown default source to just show account -->
                            </div>
                          </div>
                          <div class="row">
                            <div class="col-xl-12">
                              <div class="form-group shadow-textarea">
                                <p class="mb--20 mt-2 mb-2 text-left">
                                  <label for="notes" class="font-weight-bold">Notes:</label>
                                </p>
                                <textarea v-model="notes" class="form-control z-depth-1"
                                  id="exampleFormControlTextarea6" rows="5"
                                  placeholder="Make your notes here........."></textarea>
                              </div>
                            </div>
                          </div>
                          <div class="row" v-if="account.AllocationMethod === 'Manual' && manualAllocationsEnabled">
                            <div class="col-xl-12">
                              <div class="info-card mb-0 d-flex align-items-center" role="alert">
                                <i class="fas fa-info-circle mr-2" aria-hidden="true"></i>
                                <span>This is for a manually allocated account.</span>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="modal-footer">
            <button v-if="account.AllocationMethod === 'Manual' && manualAllocationsEnabled" type="button" class="btn btn-hc-outline float-right" :disabled="submitStatus === 'PENDING'"
              @click="submit(false)">Confirm</button>
            <button v-if="account.AllocationMethod === 'Manual' && manualAllocationsEnabled" type="submit" class="btn btn-hc float-right" :disabled="submitStatus === 'PENDING'"
              @click="submit(true)">Confirm & Allocate</button>
            <button v-if="account.AllocationMethod === 'Automatic' || !manualAllocationsEnabled" type="submit" class="btn btn-hc float-right" :disabled="submitStatus === 'PENDING'"
              @click="submit(false)">Confirm</button>
          </div>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
import { required } from "vuelidate/lib/validators";
import moment from "moment";
import Vue from "vue";

export default {
  data() {
    return {
      submitStatus: null,
      pickerDate: moment().format("YYYY-MM-DD"),
      type: "Payment",
      source: "",
      amount: null,
      notes: null,
    };
  },
  validations: {
    source: {
      required,
    },
    transactionType: {
      required,
    },
    amount: {
      required,
    },
    date: {
      required,
    },
  },
  methods: {
    submit(allocate) {
      if (this.source != "DD") {
        if (this.date == "" || !this.date) {
          this.$snotify.warning(`Please provide a date for the payment.`);
          return false;
        }
      }
      if (this.amount == "" || !this.amount) {
        this.$snotify.warning(`Please provide a payment amount.`);
        return false;
      }

      // do your submit logic here
      this.submitStatus = "PENDING";
      setTimeout(() => {
        this.$http
          .post(
            "https://" +
              Vue.config.honeycomb.moneybot.domain +
              "/api/v1/BankTransactions",
            {
              AccountId: this.$store.state.customers.customer.AccountId,
              Amount: parseFloat(this.amount),
              CreatedBy: this.userEmail,
              Collected: null,
              Description: "" + this.type + " - " + this.source + "",
              Memo: this.notes,
              Source: this.source,
              TransactionDate: this.date,
              TransactionType: this.type != "Refund" ? "Credit" : "Debit",
              Type: this.type.replace(/[_]/g, ""),
            },
            {
              withCredentials: true,
            }
          )
          .then((response) => {
            this.submitStatus = "OK";
            this.$snotify.success(`Success! Transaction complete.`);
            (this.pickerDate = moment().format("YYYY-MM-DD")),
              (this.type = "Payment"),
              (this.source = ""),
              (this.amount = null),
              (this.notes = null);

            $('#RecordManualPayment').modal('hide');

            if (allocate) {
              const transactionId = response && response.data ? response.data.Id : null;
              if (transactionId) {
                this.$router.push({
                  name: "manualAllocationsView",
                  params: {
                    transactionId: `${transactionId}`,
                    transactionType: "Bank",
                  },
                });
                return;
              }
              $('#addManualAllocation').modal('show');
            }

            this.$store.dispatch("getLedger");

            setTimeout(() => {
              this.$store.dispatch("refreshCustomer");
            }, 3000);
          })
          .catch((error) => {
            // Error
            if (error.response) {
              // The request was made and the server responded with a status code
              // that falls out of the range of 2xx
              this.submitStatus = "Error";
              if (error.response.data.MoreInformation.length > 0) {
                error.response.data.MoreInformation.forEach((e) => {
                  this.$snotify.error(`${e.Error}`, {
                    timeout: 0,
                    closeOnClick: true,
                  });
                });
              } else {
                this.$snotify.error(`${error.response.data.UserDescription}`, {
                  timeout: 0,
                  closeOnClick: true,
                });
              }
            } else if (error.request) {
              // The request was made but no response was received
              // `error.request` is an instance of XMLHttpRequest in the browser and an instance of
              // http.ClientRequest in node.js
              this.submitStatus = "Error";
              this.$snotify.error(`No response recieved.`, {
                timeout: 0,
                closeOnClick: true,
              });
            } else {
              // Something happened in setting up the request that triggered an Error
              this.submitStatus = "Error";
              this.$snotify.error(`${error.message}`, {
                timeout: 0,
                closeOnClick: true,
              });
            }
          });
      });
    },
  },
  computed: {
    userEmail() {
      return this.$auth.decodedToken.payload.sub;
    },
    date() {
      return moment.utc(this.pickerDate).format();
    },
    account() {
      return this.$store.state.customers.account;
    },
    manualAllocationsEnabled() {
      return this.$config.honeycomb.manualAllocations;
    },
  },
};
</script>
